import React, { FC } from 'react';

import { StyledTag, StyledCloseIcon } from './styles';

type Props = {
    label: string;
    onClose: () => void;
};

const Tag: FC<Props> = ({ label, onClose }) => (
    <StyledTag>
        {label}
        <StyledCloseIcon onClick={onClose} type="close-alt" />
    </StyledTag>
);

export default Tag;
